<template>
    <div id="home">
        <div class="home-container">
            <div class="top-container logo-min-height">
                <div class="left"></div>
                <div class="center">
                    <van-image
                            width="130px"
                            height="90px"
                            fit="contain"
                            :show-error="false"
                            :show-loading="false"
                            v-show="isInsert "
                            :src="logo"/>
                </div>
                <div class="right">
                    <div class="more" @click="mineClick"></div>
                </div>
            </div>
            <div class="bluetooth-battery-container">
                <div class="battery">
                    <van-image
                            width="9px"
                            height="18px"
                            fit="contain"
                            :src="battery"/>
                </div>
                <div class="disconnect-bluetooth" @click="disconnectDevice"></div>
            </div>


            <div class="taste-fun-container ">
                <div class="left ml-32"></div>
                <div class="center">
                    <smoke-progress
                            v-show="TASTE_TYPE.TASTE_TYPE_DOSAGE === tasteType || TASTE_TYPE.TASTE_TYPE_TEMPERATURE === tasteType"
                            ref="smokeProgress"
                            width="166px"
                            height="166px"
                            :progress="progress"
                            :doses="cartridgeInfoServer"
                            :puff-count="smokeData"
                            :is-insert="isInsert"
                            v-on:secondChanged="secondChanged"
                            :is-fire="isFireOrDiy"/>

                    <wave-progress
                            width="166px"
                            height="166px"
                            :preheat-status="preheatStatus"
                            :preheat-second="preheatSecond"
                            v-show="TASTE_TYPE.TASTE_TYPE_PREHEAT === tasteType"/>
                </div>
                <div class="right mr-32"></div>
            </div>
            <div>
                <TasteSettingContainer
                        class="mt-10 ml-32 mr-32"
                        v-on:tasteSettingChanged="tasteSettingChanged"
                        :taste-type="tasteType"/>
            </div>

            <PreheatContainer :preheat="preheatInfo"
                              v-on:preheatParamsChanged="preheatParamsChanged"
                              :is-start-preheat="preheatStatus"
                              v-show="TASTE_TYPE.TASTE_TYPE_PREHEAT=== tasteType"
                              class="mt-20 ml-32 mr-32"/>

            <FormulaContainer
                    v-show="isInsert && TASTE_TYPE.TASTE_TYPE_DOSAGE === tasteType"
                    :cartridge-info-server="cartridgeInfoServer"
                    :is-insert="isInsert"
                    :second="second"/>
            <!--<div class="mt-32" v-show="TASTE_TYPE.TASTE_TYPE_DOSAGE === tasteType && !isModelSDevice">-->
            <!--<DurationRingView :smoke-data="smokeData" :cartridge-info-server="cartridgeInfoServer"/>-->
            <!--</div>-->

            <div class="ml-32 mr-32  mt-24">
                <TemperatureMode :is-show="TASTE_TYPE.TASTE_TYPE_TEMPERATURE === tasteType"
                                 :is-fire="isDiy"
                                 :show-line="false"
                                 :is-concentrate="oilType"
                                 :temperature-data="temperatureMode"
                                 v-on:showConcentrateSettingChanged="showConcentrateSettingChanged"
                                 v-on:showTemperatureSettingChanged="showTemperatureSettingChanged"
                                 v-show="TASTE_TYPE.TASTE_TYPE_TEMPERATURE === tasteType"/>
            </div>


            <div class="info-container">
                <div class="btn-container">
                    <button class="ingre-btn left  ml-40 mr-2" @click="ingredientInfo">Cartridge Info</button>
                    <button class="ingre-btn right mr-40 ml-2" @click="myRecord">My Records</button>
                </div>
            </div>
            <span v-show="false">{{switchTemperatureMode}}</span>
            <span v-show="false">{{tasteSettingState}}</span>
            <span v-show="false">{{tempSelectedConcentrateComputed}}</span>
            <span v-show="false">{{outputType}}</span>
        </div>

        <van-popup v-model="isShowTemperatureModeSetting" round opened="onPopupOpened"
                   :closed="onPopupClose">
            <TemperatureSetting
                    v-on:onCloseTemperatureSetting="onCloseTemperatureSetting"
                    :temperature-data="temperatureMode"
                    :is-concentrate="oilType"
                    :is-show-changed="isShowTemperatureModeSetting"
                    :diy-temperature-mode="diyTemperatureMode"
                    :show-line="true"/>
        </van-popup>

        <van-popup v-model="isShowConcentrateSetting" round opened="onPopupOpened">
            <ConcentrateSetting :temp-selected-concentrate="tempSelectedConcentrate"
                                v-on:showConcentrateSettingChanged="onCloseConcentrateSetting"
                                v-on:onModifyConcentrateChanged="onModifyConcentrateChanged"/>
        </van-popup>
    </div>
</template>

<script>
    import log from "../repository/log/log";
    import SmokeProgress from "./SmokeProgress";
    import FormulaItem from "./FormulaItem";
    import bluetoothRepository, {
        INGREDIRENT_TYPE_SUPPLEMENT,
        PREHEAT_TYPE_ENTER,
        PREHEAT_TYPE_STOP,
        PREHEAT_STATUS, DEVICE_TYPE_MODEL_S, DEVICE_TYPE_MODEL_X, DEVICE_TYPE_MODEL_E
    } from "../repository/bluetooth/BluetoothRepository";
    import deviceRepository from "../repository/store/DeviceRepository";
    import FormulaContainer from "./FormulaContainer"
    import StoreType, {
        RECEIVED_ENTER_DIY_TEMPERATURE_CURVE,
        RECEIVED_EXIT_DIY_TEMPERATURE_CURVE
    } from "../vuex/StoreType"
    import PreheatContainer from "./PreheatContainer"
    import TasteSettingContainer from "./TasteSettingContainer"
    import WaveProgress from "./WaveProgress"
    import TemperatureMode from "./TemperatureMode"
    import TemperatureSetting from "./TemperatureSetting"
    import DurationRingView from "./DurationRingView"
    import ConcentrateSetting from "./ConcentrateSetting"

    export default {
        name      : "Home",
        components: {
            DurationRingView,
            TemperatureSetting,
            TemperatureMode,
            WaveProgress,
            TasteSettingContainer,
            PreheatContainer,
            FormulaContainer,
            SmokeProgress,
            FormulaItem,
            ConcentrateSetting
        },
        data() {
            return {
                TASTE_TYPE                  : StoreType.TASTE_TYPE,
                PREHEAT_STATUS              : PREHEAT_STATUS,
                progress                    : {
                    current: 0,
                    end    : 360,
                },
                second                      : 0,
                preheatSecond               : 12, //给预热组件倒计时用的秒数
                tasteType                   : StoreType.TASTE_TYPE.TASTE_TYPE_DOSAGE,
                isPreheating                : false,
                batteryIcon                 : {
                    level4: require("../assets/icon_e.png"),
                    level3: require("../assets/icon_e1.png"),
                    level2: require("../assets/icon_e2.png"),
                    level1: require("../assets/icon_e3.png"),
                    level0: require("../assets/icon_e4.png"),
                },
                logoIcon                    : {
                    unicore : require("../assets/logo_unicore@2x.png"),
                    dime    : require("../assets/logo_dime@2x.png"),
                    angel   : require("../assets/logo_angel@2x.png"),
                    biscuits: require("../assets/logo_biscuits@2x.png")
                },
                isShowTemperatureModeSetting: false,
                isShowConcentrateSetting    : false,
                tempSelectedConcentrate     : this.$store.state.currentConcentrateType
            }
        },
        methods   : {
            mineClick() {
                this.$router.push("Mine")
            },
            onModifyConcentrateChanged(item) {
                this.tempSelectedConcentrate = item
            },
            onCloseTemperatureSetting() {
                this.isShowTemperatureModeSetting = false
            },
            onCloseConcentrateSetting() {
                this.isShowConcentrateSetting = false
            },
            showTemperatureSettingChanged(isShow) {
                this.isShowTemperatureModeSetting = isShow
            },
            showConcentrateSettingChanged(isShow) {
                if (isShow) {
                    this.tempSelectedConcentrate = this.$store.state.selectedConcentrateType
                }
                this.isShowConcentrateSetting = isShow
            },
            secondChanged(second) {
                this.second = parseFloat(second)
            },
            disconnectDevice() {
                bluetoothRepository.disconnect();
            },
            async syncData() {
                //写入同步数据，接着会接收到蓝牙的notify，在notify那边去读取数据
                return await bluetoothRepository.syncSmokeData()
            },
            //从服务器上获取烟弹信息
            async getCartridgeInfoFromServer() {
                const podId      = this.$store.state.deviceInfo.podId
                const batchNum   = this.$store.state.deviceInfo.batchId
                const macAddress = this.$store.state.deviceInfo.macAddress
                log(`home pod id = ${podId} batchNum = ${batchNum}`);
                if (podId == '' || batchNum == '' || macAddress == '') {
                    return
                }

                //设备连接
                await deviceRepository.deviceConnection(batchNum, macAddress, podId)
                const cartridgeInfoServer = await deviceRepository.cartridgeInfo(`${batchNum}&${podId}`)

                this.$store.commit(StoreType.COMMIT_TYPE.COMMIT_CARTRIDGE_INFO_SERVER, cartridgeInfoServer)
                return cartridgeInfoServer
            },
            //从服务器上获取烟弹信息
            async updateCartridgeInfoFromServer(podId, batchNum) {
                const macAddress = this.$store.state.deviceInfo.macAddress
                log(`home pod id = ${podId} batchNum = ${batchNum}`);

                //设备连接
                await deviceRepository.deviceConnection(batchNum, macAddress, podId)
                const cartridgeInfoServer = await deviceRepository.cartridgeInfo(`${batchNum}&${podId}`)

                this.$store.commit(StoreType.COMMIT_TYPE.COMMIT_CARTRIDGE_INFO_SERVER, cartridgeInfoServer)
                return cartridgeInfoServer
            },

            //监听vuex的烟弹信息状态变化
            ingredientInfo() {
                this.$router.push({name: 'IngredientInfo', params: {cartridgeInfo: this.cartridgeInfoServer}})
            },
            //跳转到我的记录
            myRecord() {
                this.$router.push({name: 'MyRecord'})
            },
            //预热点击
            preheatClick() {
                this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_PREHEAT
            },
            //温度点击
            temperatureClick() {
                this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_TEMPERATURE

            },
            //子组件发射出来的事件数据
            tasteSettingChanged(type) {
                const lastTasteType = this.tasteType
                this.tasteType      = type

                if (type === StoreType.TASTE_TYPE.TASTE_TYPE_PREHEAT) {  //如果是预热状态
                    bluetoothRepository.changeOutputMode(1)
                    // this.$store.commit(StoreType.COMMIT_TYPE.COMMIT_SWITCH_TEMPERATURE_MODE, -1)
                    // if (this.deviceInfo.cartridgeFlag !== DEVICE_TYPE_MODEL_S) { //但是又不是wax设备，则读取预热的信息
                    //     bluetoothRepository.writePreheat(PREHEAT_TYPE_ENTER, this.preheatInfo.preheatTemperature,
                    //         this.preheatInfo.preheatSecond)
                    // }
                } else if (type === StoreType.TASTE_TYPE.TASTE_TYPE_TEMPERATURE) {
                    bluetoothRepository.changeOutputMode(2)
                    // if (this.deviceInfo.cartridgeFlag === DEVICE_TYPE_MODEL_X ||
                    //     this.deviceInfo.cartridgeFlag === DEVICE_TYPE_MODEL_E) {
                    //     bluetoothRepository.writeTemperatureMode(this.$store.state.temperatureMode)
                    // }
                } else {
                    bluetoothRepository.changeOutputMode(0)
                    // if (this.deviceInfo.cartridgeFlag !== DEVICE_TYPE_MODEL_S) {
                    //     this.$store.commit(StoreType.COMMIT_TYPE.COMMIT_SWITCH_TEMPERATURE_MODE, -1)
                    //     bluetoothRepository.writePreheat(PREHEAT_TYPE_STOP, 50, 35)
                    // }
                }
            },
            //预热参数改变
            preheatParamsChanged(item) {
                switch (item) {
                    case 1:
                        bluetoothRepository.writePreheat(PREHEAT_TYPE_ENTER, 55, 30)
                        this.preheatSecond = 30
                        break;
                    case 2:
                        bluetoothRepository.writePreheat(PREHEAT_TYPE_ENTER, 50, 45)
                        this.preheatSecond = 45
                        break;
                    case 3:
                        bluetoothRepository.writePreheat(PREHEAT_TYPE_ENTER, 60, 15)
                        this.preheatSecond = 15
                        break;
                    case 4:
                        bluetoothRepository.writePreheat(PREHEAT_TYPE_ENTER, this.preheatInfo.preheatTemperature,
                            this.preheatInfo.preheatSecond)
                        this.preheatSecond = this.preheatInfo.preheatSecond
                        break;
                }
            },
            onPopupOpened() {
                log("打开弹框")
            },

            onPopupClose() {
                log("关闭弹框")
            }
        },

        watch: {
            isFireOrDiy(val, oldVal) {
                if (val === oldVal) return;
                if (this.$refs.smokeProgress) {
                    this.$refs.smokeProgress.stop();
                    if (val) {
                        if (this.tasteType === StoreType.TASTE_TYPE.TASTE_TYPE_PREHEAT) {
                            this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_DOSAGE
                        }
                        this.progress = {current: 0, end: 2160};
                        this.$refs.smokeProgress.start();
                    } else {
                        this.$refs.smokeProgress.stop();
                    }
                }
            },
            isInsert(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue) {

                        this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_DOSAGE
                        this.progress  = {
                            current: 0,
                            end    : 360
                        };
                        this.$refs.smokeProgress.start();

                        bluetoothRepository.fetchDeviceData().then(data => {
                            return this.getCartridgeInfoFromServer()
                        }).then(data => {

                        })
                    } else {
                        this.$refs.smokeProgress.stop();
                    }
                } else {
                    this.$refs.smokeProgress.stop();
                }
            },

            switchTemperatureMode(newValue, oldValue) {
                if (newValue === RECEIVED_ENTER_DIY_TEMPERATURE_CURVE) {
                    this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_TEMPERATURE
                } else if (oldValue === RECEIVED_EXIT_DIY_TEMPERATURE_CURVE) {
                    this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_DOSAGE
                }
            },

            tasteSettingState(newValue, oldValue) {
                this.tasteType = newValue
            },

            isShowTemperatureModeSetting(newValue, oldValue) {
                log("变化了 " + newValue)
                if (!oldValue) {

                }
            },

            tempSelectedConcentrateComputed(newValue, oldValue) {
                this.tempSelectedConcentrate = newValue
            },
        },

        computed: {
            tempSelectedConcentrateComputed() {
                return this.$store.state.currentConcentrateType
            },

            switchTemperatureMode() {
                return this.$store.state.switchTemperatureMode
            },
            deviceInfo() {
                return this.$store.state.deviceInfo;
            },

            smokeData() {
                return this.$store.state.deviceInfo.usageSecond;
            },

            isFire() {
                return this.deviceInfo.isFire;
            },


            isFireOrDiy() {
                return this.isFire || this.isDiy;
            },


            isDiy() {
                const isDiy = this.$store.state.isDiy
                if (isDiy) {
                    this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_TEMPERATURE
                }
                return isDiy;
            },
            preheatStatus() {
                const isPreheat = this.$store.state.isPreheat
                if (isPreheat) {
                    this.tasteType = StoreType.TASTE_TYPE.TASTE_TYPE_PREHEAT
                }
                return isPreheat
            },
            isInsert() {
                const isInsert = this.deviceInfo.isInsert
                if (!isInsert) {
                    this.second = 0
                }
                return isInsert;
            },

            cartridgeInfoServer() {
                let cartridgeInfoServer = this.$store.state.cartridgeInfoServer;
                let secondInTake        = 0
                let mainProportion      = 0
                if (cartridgeInfoServer) {
                    const ingredirentType = this.$store.state.oilType
                    if (ingredirentType === INGREDIRENT_TYPE_SUPPLEMENT) {
                        secondInTake = cartridgeInfoServer.dose * 1000 / 0.8 / 450 * cartridgeInfoServer.dose
                    } else {
                        secondInTake = cartridgeInfoServer.dose * 1000 / 450 * cartridgeInfoServer.dose
                    }

                    if (cartridgeInfoServer.formulaList && cartridgeInfoServer.formulaList.length > 0) {
                        mainProportion = cartridgeInfoServer.formulaList[0].proportion
                    }
                    const maxProportion = secondInTake * mainProportion / 100 / 100 * 12
                    const intake        = {
                        secondInTake,
                        mainProportion,
                        maxProportion
                    }
                    cartridgeInfoServer = {...cartridgeInfoServer, ...intake}
                    return cartridgeInfoServer
                }
                return null
            },

            battery() {
                const battery   = this.$store.state.battery
                let batteryIcon = this.batteryIcon.level4
                if (battery <= 40) {
                    batteryIcon = this.batteryIcon.level1
                } else if (battery <= 55) {
                    batteryIcon = this.batteryIcon.level2
                } else if (battery <= 70) {
                    batteryIcon = this.batteryIcon.level3
                } else if (battery === 0) {
                    batteryIcon = this.batteryIcon.level4
                }
                return batteryIcon
            },
            logo() {
                let icon = this.logoIcon.unicore
                if (this.$store.state.deviceInfo.brandType) {
                    switch (this.$store.state.deviceInfo.brandType) {
                        case 2:
                            icon = this.logoIcon.unicore
                            break;
                        case 3:
                            icon = this.logoIcon.dime
                            break;
                        case 4:
                            icon = this.logoIcon.angel
                            break;
                        case 5:
                            icon = this.logoIcon.biscuits
                            break;
                        default:
                            icon = null
                    }
                }

                return icon
            },

            preheatInfo() {
                return this.deviceInfo.preheatTemperatureAndTime
            },

            temperatureMode() {
                return this.deviceInfo.temperatureMode
            },

            isModelSDevice() {
                return this.deviceInfo.cartridgeFlag === DEVICE_TYPE_MODEL_S
            },
            tasteSettingState() {
                return this.$store.state.tasteSetting || 2
            },

            oilType() {
                const concentrateType = this.$store.state.oilType === 4
                if (concentrateType) {
                    deviceRepository.concentrateTypeList(this.$store.state.deviceInfo.podId)
                }
                return concentrateType
            },

            outputType() {
                const outputMode = this.$store.state.outputMode
                switch (outputMode) {
                    case 0:
                        this.tasteType =  StoreType.TASTE_TYPE.TASTE_TYPE_DOSAGE
                        break
                    case 1:
                        this.tasteType =  StoreType.TASTE_TYPE.TASTE_TYPE_PREHEAT
                        break
                    case 2:
                        this.tasteType =  StoreType.TASTE_TYPE.TASTE_TYPE_TEMPERATURE
                        break
                }
                return outputMode
            },


            temperatureModeServer() {
                if (this.oilType) {
                    const temperatureData         = []
                    const selectedConcentrateType = this.$store.state.selectedConcentrateType
                    if (selectedConcentrateType) {
                        selectedConcentrateType.heatingMode || selectedConcentrateType.heatingMode.forEach((item, index) => {
                            temperatureData.push({
                                name             : item.operatingModeName,
                                secondTemperature: temperature.split(","),
                                isCustomMode     : item.isCustomMode,
                                isSelected       : false
                            })
                        })
                    }
                    return temperatureData
                } else {
                    return this.$store.state.temperatureMode
                }
            },

            selectedConcentrateType() {
                return this.$store.state.selectedConcentrateType
            },

            diyTemperatureMode() {
                if (this.oilType) {
                    const temperatureData = []

                    if (this.selectedConcentrateType) {
                        this.selectedConcentrateType.heatingModeList && this.selectedConcentrateType.heatingModeList.forEach((item, index) => {
                            temperatureData.push({
                                name             : item.operatingModeName,
                                secondTemperature: item.temperature.split(",").map((item, i) => {
                                    return {x: (i + 1), y: parseFloat(item)}
                                }),
                                isCustomMode     : item.isCustomModel,
                                isSelected       : false,
                                concentrateId    : this.selectedConcentrateType.id
                            })
                        })
                    }
                    return temperatureData
                }

                if (this.$store.state.diyTemperatureMode) {
                    return this.$store.state.diyTemperatureMode || []
                }
                return  []
            },

        },

        activated() {
            if (!bluetoothRepository.isConnected()) {
                return
            }
            this.getCartridgeInfoFromServer().then(data => {
                return bluetoothRepository.syncTime(this.deviceInfo.macAddress, this.deviceInfo.deviceName)

            })
                .then(data => {
                    if (data == null) return null
                   return deviceRepository.diyTemperatureMode(this.deviceInfo.podId)
                })
                .then(data => {
                    if (data == null) return null
                    return bluetoothRepository.syncSmokeData()
                })
        },

        mounted() {
        },
    }
</script>

<style lang="scss">
    #home {
        background: #111111;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .home-container {
        flex: 1;
        width: 100%;
        padding-bottom: 60px;

        .top-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;

            .left {
                flex: 1;
                text-align: left;
            }

            .center {
                flex: 4;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .right {
                flex: 1;
                text-align: right;
            }
        }

        .taste-fun-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            text-align: center;
            color: #999999;
            font-size: 12px;
            width: 100%;

            .left {
                flex: 1;
            }

            .center {
                flex: 2;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                align-content: center;
            }

            .right {
                flex: 1;
            }
        }

        .bluetooth-battery-container {
            display: flex;
            margin-top: 16px;
            flex-direction: row-reverse;
            align-items: center;
            width: 100%;

            .battery {
                width: 8px;
                height: 18px;
                margin-right: 16px;
            }

            .disconnect-bluetooth {
                width: 13px;
                height: 15px;
                margin-right: 16px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                @include bg-image("../assets/Bluetooth");
            }
        }

        .logo {
            margin-top: 32px;
            width: 120px;
            height: 30px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            @include bg-image("../assets/dime-logo");
        }

        .more {
            position: absolute;
            padding: 2px;
            width: 13px;
            height: 13px;
            right: 16px;
            top: 38px;
            background-repeat: no-repeat;
            background-position: right;
            background-size: cover;
            @include bg-image("../assets/more");
        }


        .info-container {
            position: fixed;
            bottom: 0px;
            width: 100%;

            .btn-container {

                background: #222222;
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                padding-top: 10px;
                padding-bottom: 10px;

                .left {
                    flex: 1;
                    text-align: center;
                }

                .center {
                    flex: 1;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .right {
                    flex: 1;
                    text-align: center;
                }


                .ingre-btn {
                    color: #F6F6F6;
                    border-radius: 12px;
                    padding: 12px;
                    text-align: center;
                    background: #000000;
                    border: none;
                }
            }
        }

    }

    .logo-min-height {
        min-height: 90px;
    }

</style>
